var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 14,
    viewBox: "0 0 25 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mastercard"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Left",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2714 12.1569C10.9777 13.1852 9.29956 13.806 7.46579 13.806C3.3741 13.806 0.0571289 10.7154 0.0571289 6.90299C0.0571289 3.09057 3.3741 0 7.46579 0C9.29956 0 10.9777 0.620752 12.2714 1.64903C13.5651 0.620752 15.2433 0 17.077 0C21.1687 0 24.4857 3.09057 24.4857 6.90299C24.4857 10.7154 21.1687 13.806 17.077 13.806C15.2433 13.806 13.5651 13.1852 12.2714 12.1569Z",
    fill: "#ED0006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Right",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2714 12.1569C13.8643 10.8908 14.8744 9.0068 14.8744 6.90299C14.8744 4.79917 13.8643 2.91517 12.2714 1.64903C13.5651 0.620752 15.2432 0 17.077 0C21.1687 0 24.4857 3.09057 24.4857 6.90299C24.4857 10.7154 21.1687 13.806 17.077 13.806C15.2432 13.806 13.5651 13.1852 12.2714 12.1569Z",
    fill: "#F9A000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Middle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2715 12.1573C10.6785 10.8911 9.66846 9.00714 9.66846 6.90334C9.66846 4.79954 10.6785 2.91555 12.2715 1.64941C13.8644 2.91555 14.8745 4.79954 14.8745 6.90334C14.8745 9.00714 13.8644 10.8911 12.2715 12.1573Z",
    fill: "#FF5E00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.cbeaf3b920a2052b6f4780663ae96a10.svg";
export { ForwardRef as ReactComponent };